import * as React from "react";

import { usePlpPresenterForTheProductsMasonry } from "../providers";

export const MobileMasonryColumnSelector: React.FunctionComponent = () => {
  const {
    showMasonryWithTwoColumns_onMobile,
    handleShowMasonryWithOneColumn_onMobile,
    handleShowMasonryWithTwoColumns_onMobile,
  } = usePlpPresenterForTheProductsMasonry();

  return (
    <div className="mobile-masonry-column-selector">
      <div
        className={`one-column ${
          showMasonryWithTwoColumns_onMobile ? "" : "active"
        }`}
        onClick={handleShowMasonryWithOneColumn_onMobile}
      >
        <div className="item" />
      </div>
      <div
        className={`two-column ${
          showMasonryWithTwoColumns_onMobile ? "active" : ""
        }`}
        onClick={handleShowMasonryWithTwoColumns_onMobile}
      >
        <div className="item" />
        <div className="item" />
        <div className="item" />
        <div className="item" />
      </div>
    </div>
  );
};
